<script lang="ts">
  import { containsService, paramsService } from '../services';
  import type { Contain } from '../Model/Contain';
  import type { Param } from '../Model/Param';

  export let containSelectId: string;
  export let module : string;

  let contains: Contain[];
  let containsShow: Contain[] = [];
  let params: Param[];


  load(module);

  export async function load(module) {

    params = await paramsService.findByType('modules');
    contains = await containsService.find();

    const paramSelect = params.find(p => p.name == module);

    if (!paramSelect) {
      return;
    }

    for (const contain of contains) {
      if (contain.moduleId == paramSelect.id) {
        containsShow.push(contain)
      }
    }

    containsShow.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    return containsShow = containsShow;
  }

</script>

{#if containsShow}
  <div class="input-group">
    <select class="form-select" bind:value={containSelectId}>
      {#each containsShow as contain}
        <option value={contain.id}>{contain.name}</option>
      {/each}
    </select>
  </div>
{/if}

<style>
</style>
